//import references
import { Component } from 'react';

import { CircularProgress, Typography } from '@material-ui/core';
import DataGrid, {
  Column,
  Paging,
  RowDragging,
  Scrolling,
  Sorting
} from 'devextreme-react/data-grid';
import MUIDataTable from 'mui-datatables';
import 'react-toastify/dist/ReactToastify.css';
import { getDatafromApi } from '../calls';
import { ApiData } from "../config";

let daysData;


class WebPoint extends Component {

  constructor(props) {
    super(props);
    this.onReorder = this.onReorder.bind(this);

    this.state = {
      data: [['Loading Data...']],
      dataGPX: [['Loading Data...']],
      loading: false,
       loading1: false,
       loading2: false,
      dragWebPOIsKeys: [],
      selectedWebPOIsKeys: [{ "id": '', "name": "Loading...", "country": "" },],
      defaultSelectedRow: [],
      defaultSelectedRowGPX: [],
    };
  }

  onReorder(e) {
    const visibleRows = e.component.getVisibleRows();
    const newWebPOI = [...this.props.selectedWebPOIsKeys];
    const toIndex = newWebPOI.indexOf(visibleRows[e.toIndex].data);
    const fromIndex = newWebPOI.indexOf(e.itemData);

    newWebPOI.splice(fromIndex, 1);
    newWebPOI.splice(toIndex, 0, e.itemData);
    this.setState({
      selectedWebPOIsKeys: newWebPOI,
    });
    this.props.setSelectedWebPoi(newWebPOI);

    this.props.setSelectedWebPOIsKeys(newWebPOI)
    const selectedRowKeys = newWebPOI.map((item) => item.id);
    this.props.setglobalPoiSet(selectedRowKeys)
  }

  onSelectionChanged = ({ selectedRowKeys, selectedRowsData }) => {
    // this.selectionChangedBySelectBox = false;
    this.setState({
      dragWebPOIsKeys: selectedRowKeys,
    });
  };

  async componentDidMount() {
    await this.getData()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.globalPoiSet && this.props.openModalDay && this.props.saveType !== 'add') {
      if (this.state.data !== prevState.data || this.props.globalPoiSet !== prevProps.globalPoiSet) {
        if (this.state.data) {
          let poiDefault = []
          let poiArr = this.props.globalPoiSet.map(Number);
          let index = []
          this.state.data.forEach((poi, i) => {
            poiArr.forEach(el => {
              if (el === poi.id) {
                poiDefault.push(poi)
                index.push(i)
              }

            });
          });
          let sortedData = poiDefault.sort((a, b) => poiArr.indexOf(a.id) - poiArr.indexOf(b.id));
          this.props.setSelectedWebPOIsKeys(sortedData)
          this.setState({ defaultSelectedRow: index })
        }
      }
    }
    if (this.props.openModalDay !== prevProps.openModalDay) {
      if (!this.props.openModalDay) {
        let unSelectPois = this.state.data.map(poi => {
          if (poi.selected1 === true) {
            poi.selected1 = false;
          }
          return poi;
        });
        this.setState({ data: unSelectPois, defaultSelectedRow: [] })
      }
    }

  }

  getData = () => {
    this.setState({ loading: true });
    this.xhrRequest().then((data) => {
      this.setState({ data, loading: false });
    });
    this.setState({ loading1: true });
    this.xhrRequest1().then((data1) => {
      this.setState({ dataGPX:data1, loading1: false });
    });
  };

  xhrRequest = (url) => {
    return new Promise(async (resolve, reject) => {
      let data1 = await getDatafromApi(ApiData.apiUrl + '/global-poi/');
      if (data1) {

        let data = data1.results.filter(function (item) { return (item.personalized === false); });
 for (let i = 0; i < data.length; i++) {
          if (data[i].type === 0)
            data[i].originalType = "POI";
          data[i].sortId = data[i].id;
          if (data[i].type === 1)
            data[i].originalType = "INFORMATION POINT";
          data[i].sortId = data[i].id;
          if (data[i].type === 2)
            data[i].originalType = "GPX";
          data[i].sortId = data[i].poi;
          if (data[i].type === 3)
            data[i].originalType = "TRAILPACKAGE";
          if (this.props.globalPoiSet.indexOf(data[i].id) > -1) {
            data[i].selected1 = 'true';
          }
          if (data[i].attraction_id)
            data[i].originalType = "ATTRACTION";
        }
        if (this.props.globalPoiSet) {
          let poiArr = this.props.globalPoiSet.map(Number);
          let poiDefault = []
          let poisWithSelected = data.map(poi => {
            if (poiArr.includes(poi.id)) {
              poiDefault.push(poi)
              return { ...poi, selected1: true };
            }
            return poi;
          });
          let sortedData = poiDefault.sort((a, b) => poiArr.indexOf(a.id) - poiArr.indexOf(b.id));
          this.props.setSelectedWebPOIsKeys(sortedData)
          daysData = poisWithSelected;

          resolve(poisWithSelected);
          this.setselectedRecord();
        } else {
          daysData = data;
          resolve(data);
        }

        let webpoikey = [];
        for (let i = 0; i < this.props.globalPoiSet.length; i++) {
          for (let j = 0; j < this.props.selectedWebPOIsKeys.length; j++) {
            if (this.props.globalPoiSet[i] === this.props.selectedWebPOIsKeys[j].id)
              webpoikey.push(this.props.selectedWebPOIsKeys[j])
          }
        }
        this.props.setSelectedWebPoi(webpoikey);
      }
    });
  };



 xhrRequest1 = (url) => {
    return new Promise(async (resolve, reject) => {
      let data = await getDatafromApi(ApiData.apiUrl + '/gpxs?take=3000&personalized=false');
      data.results.sort((a, b) => a.id - b.id);
      let gpxs = data.results.filter(function (item) { return (item.type === 0 && item.poi); });
      for (let i = 0; i < gpxs.length; i++) {
        if (gpxs[i].type === 0)
          gpxs[i].originalType = "POI";
        if (gpxs[i].type === 1)
          gpxs[i].originalType = "INFORMATION POINT";
        if (gpxs[i].type === 2)
          gpxs[i].originalType = "GPX";
        if (gpxs[i].type === 3)
          gpxs[i].originalType = "TRAILPACKAGE";
        if (this.props.globalPoiSet.indexOf(gpxs[i].poi) > -1) {
          gpxs[i].selected1 = 'true';
        }
      }
      resolve(gpxs);
    });
  };
setGPXselectedRecord() {
    let selectedWebPOIsKeys1 = [...this.props.selectedWebPOIsKeys];
    let defaultSelectedRow2 = [];
    for (let i = 0; i < this.state.dataGPX.length; i++) {
      if (this.state.dataGPX[i].selected1) {
        let flg = 1
        for (let j = 0; j < this.props.selectedWebPOIsKeys.length; j++) {
          if (this.props.selectedWebPOIsKeys[j].id === this.state.dataGPX[i].id && this.props.selectedWebPOIsKeys[j].type === 'GPX') {
            flg = 0
          }
        }
        defaultSelectedRow2.push(i);

        if (flg === 1) {
          //this.props.selectedVG.push(this.state.dataPOI[i])
          let r1 = this.state.dataGPX[i];
          r1.type = 'GPX';
          r1.originalType = "GPX";
          selectedWebPOIsKeys1.push(r1)
        }
      }

    }
    this.setState({ defaultSelectedRowGPX: defaultSelectedRow2 });
    this.setSelectedRows(selectedWebPOIsKeys1, 'GPX')
  }
  setselectedRecord() {
    let selectedWebPOIsKeys1 = [...this.props.selectedWebPOIsKeys];
    let defaultSelectedRow1 = []

    for (let i = 0; i < daysData.length; i++) {
      if (daysData[i].selected1) {
        let flg = 1
        for (let j = 0; j < this.props.selectedWebPOIsKeys.length; j++) {
          if (this.props.selectedWebPOIsKeys[j].id === daysData[i].id) {
            flg = 0
          }
        }
        defaultSelectedRow1.push(i);


        if (flg === 1) {
          //this.props.selectedWebPOIsKeys.push(daysData[i])
          selectedWebPOIsKeys1.push(daysData[i])
        }
      }

    }

    let selectedWebPOIsKeysNew = []

    for (let i = 0; i < selectedWebPOIsKeys1.length; i++) {
      for (let j = 0; j < daysData.length; j++) {

        if ((daysData[j].id === selectedWebPOIsKeys1[i].id) && daysData[j].selected1) {
          selectedWebPOIsKeysNew.push(daysData[j])
        }
      }
    }
    this.props.setSelectedWebPoi(selectedWebPOIsKeysNew);
    this.setState({ defaultSelectedRow: defaultSelectedRow1 });
  }

  render() {
    const columns = [
      { name: 'id', options: { label: 'ID', filter: false, } },
      { name: 'name', label: 'Name', options: { filter: false } },
      { name: 'country', label: 'Country' },
      { name: 'attraction_id', label: 'Attraction ID' },
    ];

    const onRowsSelect = (curRowSelected, rowsSelected, rowMeta) => {
      const daysPois = [...this.state.data]
      const selectedPois = [...this.state.defaultSelectedRow]
      let globalPoiSet1 = [...this.props.globalPoiSet];
      let selectedWebPOIsKeys1 = [...this.props.selectedWebPOIsKeys];
      if (daysPois[curRowSelected[0].dataIndex].selected1) {
        daysPois[curRowSelected[0].dataIndex].selected1 = false;
        let a = globalPoiSet1.filter(function (item) { return item !== daysPois[curRowSelected[0].dataIndex].id });
        let b = selectedWebPOIsKeys1.filter(function (item) {
          return item.id !== daysPois[curRowSelected[0].dataIndex].id;
        });
        this.props.setglobalPoiSet(a);
        this.props.setSelectedWebPOIsKeys(b)
        this.setState({})
      }
      else {
        selectedPois.push(curRowSelected[0].dataIndex)
        daysPois[curRowSelected[0].dataIndex].selected1 = true;
        globalPoiSet1.push(String(daysPois[curRowSelected[0].dataIndex].id));
        selectedWebPOIsKeys1.push(daysPois[curRowSelected[0].dataIndex])
        this.props.setglobalPoiSet(globalPoiSet1);
        this.props.setSelectedWebPOIsKeys(selectedWebPOIsKeys1)
        this.setState({ defaultSelectedRow: selectedPois })
      }

      this.setselectedRecord();
      this.props.setSelectedVgByWeb(daysPois[curRowSelected[0].dataIndex])

    };
    const { data } = this.state;
    data.sort((a, b) => a.id - b.id);
    const options = {
      filter: true,
      filterType: 'dropdown',
      responsive: 'standard',
      download: false,
      print: false,
      selectableRowsOnClick: false,
      selectToolbarPlacement: 'none',
      rowsSelected: this.state.defaultSelectedRow,
      onRowSelectionChange: onRowsSelect,
    };





 const columnsGPX = [
      { name: 'id', options: { label: 'ID', filter: false, } },
      { name: 'name', label: 'Name', options: { filter: false } },
      { name: 'country', label: 'Country' },
    ];

    const onRowsSelectGPX = (curRowSelected, rowsSelected, rowMeta) => {
      let globalPoiSet2 = [...this.props.globalPoiSet];
      if (this.state.dataGPX[curRowSelected[0].dataIndex].selected1) {
        const newDataGPX = [...this.state.dataGPX];
        newDataGPX[curRowSelected[0].dataIndex] = { ...newDataGPX[curRowSelected[0].dataIndex], selected1: false };
        this.setState({ dataGPX: newDataGPX });

        let matchPOI = this.state.dataGPX[curRowSelected[0].dataIndex].poi;
        let a = globalPoiSet2.filter(function (item) {
          return item !== matchPOI;
        });
        this.props.setglobalPoiSet(a);
      }
      else {
        if (this.state.dataGPX[curRowSelected[0].dataIndex].poi) {
          const newDataGPX = [...this.state.dataGPX];
          newDataGPX[curRowSelected[0].dataIndex] = { ...newDataGPX[curRowSelected[0].dataIndex], selected1: true };
          this.setState({ dataGPX: newDataGPX });
          globalPoiSet2.push(this.state.dataGPX[curRowSelected[0].dataIndex].poi);
          this.props.setglobalPoiSet(globalPoiSet2);
          let data = [...this.props.globalPoiSet]
          data.push(this.state.dataGPX[curRowSelected[0].dataIndex])
          this.props.setSelectedWebPoi(data)
        }
      }

      this.setGPXselectedRecord();
    };

    const optionsGPX = {
      filter: true,
      filterType: 'dropdown',
      responsive: 'standard',
      download: false,
      print: false,
      selectableRowsOnClick: false,
      selectToolbarPlacement: 'none',
      rowsSelected: this.state.defaultSelectedRowGPX,
      onRowSelectionChange: onRowsSelectGPX,
    };






    return (
      <table>

        <tr>
          <td style={{ width: '40%' }}>
            <h4> Select from country POIs: </h4>
          </td>
          <td style={{ width: '5%' }}>

          </td>
          <td style={{ width: '55%' }}>
            <h4> order Selected POIs: </h4>
          </td>
        </tr>

        <tr>
          <td style={{ width: '40%' }}>

            <div>
              <MUIDataTable
                title={
                  <Typography variant="subtitle2">
                    {this.state.loading && (
                      <CircularProgress
                        size={24}
                        style={{ marginLeft: 15, position: 'relative', top: 4 }}
                      />
                    )}
                  </Typography>
                }
                data={data}
                columns={columns}
                options={options}
                rowsSelected={onRowsSelect}
                rowMeta={[0, 1]}
              />
            </div>

 <h4> Select from country GPXs:</h4>
            <div>
              <MUIDataTable
                title={
                  <Typography variant="subtitle2">
                    {this.state.loading1 && (
                      <CircularProgress
                        size={24}
                        style={{ marginLeft: 15, position: 'relative', top: 4 }}
                      />
                    )}
                  </Typography>
                }
                data={this.state.dataGPX}
                columns={columnsGPX}
                options={optionsGPX}
                rowsSelected={onRowsSelect}
                rowMeta={[0, 1]}
              />
            </div>



          </td>
          <td style={{ width: '10%' }}>

          </td>
          <td style={{ width: '45%', WebkitPaddingEnd: 100, verticalAlign: 'baseline' }} className="mytable">

            <DataGrid
              // height={440}
              dataSource={this.props.selectedWebPOIsKeys}
              keyExpr="id"
              showBorders={true}
              ref={(ref) => (this.dataGrid = ref)}
              selectableRows={false}
              expandableRowsHeader={false}
              onSelectionChanged={this.onSelectionChanged}
              selectedRowKeys={this.state.dragWebPOIsKeys}
            >
              <RowDragging
                allowReordering={true}
                onReorder={this.onReorder}
                showDragIcons={true}
              />

              <Scrolling mode="virtual" />
              <Sorting mode="none" />

              <Column dataField="id" width={60} />
              <Column dataField="name" />
              <Column dataField="country" />
              <Column dataField="originalType" />
              <Paging defaultPageSize={10} />
            </DataGrid>

          </td>
        </tr>
      </table >
    );
  }
}
export default WebPoint;
